module.exports = __webpack_public_path__ + "media/images/meta/admin/apple-touch-icon-staging-c111065abd6cffcba4d77075e1e14102.png";